import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SiaRadarService {
  finalSelectionChanged: Subject<any> = new Subject();
  selectionChanged: Subject<any> = new Subject();

  constructor() {}

  finalSelectionChanged$() {
    return this.finalSelectionChanged.asObservable();
  }

  selectionChanged$() {
    return this.selectionChanged.asObservable();
  }
}
